import React from "react";
import { useNavigate } from "react-router-dom";

// mui components
import { Stack, TableCell, TableRow } from "@mui/material";

// custom components
import Body1 from "../../typography/body-01";

// custom icons
import WarningIcon from "../../../assets/icons/warning-icon";

// custom styles
import styles from "../index.module.scss";

const PipelineRow = ({ row }) => {
	const navigate = useNavigate();

	let loanStatus;

	loanStatus =
		row?.fields["Loan.LoanFolder"] === "Portal - Not Submitted"
			? "Started - Not Submitted"
			: row?.fields["Fields.Log.MS.CurrentMilestone"] === "Started" &&
				  !row?.fields["Fields.TPO.X90"]
				? "Started - Not Submitted"
				: row?.fields["Fields.Log.MS.CurrentMilestone"] === "Started"
					? "Loan Submitted"
					: row?.fields["Fields.Log.MS.CurrentMilestone"] === "Loan Submitted"
						? "Loan Submitted"
						: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
							  "Review Submission"
							? "Review Submission"
							: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
								  "Incomplete Credit Pkg"
								? "Incomplete Credit Pkg"
								: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
									  "Recd Cred Pkg"
									? "Rec'd Credit Pkg"
									: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
										  "Review Cred Pkg"
										? "Rec'd Credit Pkg"
										: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
											  "File Setup"
											? "File Setup"
											: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
												  "Submit to UW"
												? "Submitted to UW"
												: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
													  "In UWing Review"
													? "In UWing Review"
													: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
														  "Suspended"
														? "In UWing Review"
														: row?.fields["Fields.Log.MS.CurrentMilestone"] ===
															  "Cond'l Approval"
															? "Cond'l Approval"
															: row?.fields[
																		"Fields.Log.MS.CurrentMilestone"
																  ] === "Recd Conditions"
																? "Condition Review"
																: row?.fields[
																			"Fields.Log.MS.CurrentMilestone"
																	  ] === "UW Cond Review"
																	? "Condition Review"
																	: row?.fields[
																				"Fields.Log.MS.CurrentMilestone"
																		  ] === "QC Requested"
																		? "Condition Review"
																		: row?.fields[
																					"Fields.Log.MS.CurrentMilestone"
																			  ] === "QC Complete"
																			? "Condition Review"
																			: row?.fields[
																						"Fields.Log.MS.CurrentMilestone"
																				  ] === "CTC"
																				? "Clear to Close"
																				: row?.fields[
																							"Fields.Log.MS.CurrentMilestone"
																					  ] === "Closing Prep"
																					? "Closing Docs"
																					: row?.fields[
																								"Fields.Log.MS.CurrentMilestone"
																						  ] === "Closing"
																						? "Closing"
																						: row?.fields[
																									"Fields.Log.MS.CurrentMilestone"
																							  ] === "Funding Prep"
																							? "Wire Sent"
																							: row?.fields[
																										"Fields.Log.MS.CurrentMilestone"
																								  ] === "Funding"
																								? "Funded"
																								: row?.fields[
																											"Fields.Log.MS.CurrentMilestone"
																									  ] === "Recd Closing Pkg"
																									? "Rec'd Closing Pkg"
																									: row?.fields[
																												"Fields.Log.MS.CurrentMilestone"
																										  ] === "Review Closing Pkg"
																										? "Review Closing Pkg"
																										: row?.fields[
																													"Fields.Log.MS.CurrentMilestone"
																											  ] === "Purch Suspended"
																											? "Purch Suspended"
																											: row?.fields[
																														"Fields.Log.MS.CurrentMilestone"
																												  ] ===
																												  "Recd Purch Conditions"
																												? "Rec'd Purch Conditions"
																												: row?.fields[
																															"Fields.Log.MS.CurrentMilestone"
																													  ] ===
																													  "Review Purch Conditions"
																													? "Review Purch Conditions"
																													: row?.fields[
																																"Fields.Log.MS.CurrentMilestone"
																														  ] ===
																														  "Cleared 4 Purch"
																														? "Cleared 4 Purch"
																														: row?.fields[
																																	"Fields.Log.MS.CurrentMilestone"
																															  ] ===
																															  "Create PA"
																															? "Create PA"
																															: row?.fields[
																																		"Fields.Log.MS.CurrentMilestone"
																																  ] ===
																																  "Request Wire"
																																? "Request Wire"
																																: row?.fields[
																																		"Fields.Log.MS.CurrentMilestone"
																																	] ===
																																		"Purchase" &&
																																	"Purchase";

	let loanIncompleteStatusBoolean =
		row?.fields["Loan.LoanFolder"] === "Portal - Not Submitted" ||
		(row?.fields["Fields.Log.MS.CurrentMilestone"] === "Started" &&
			!row?.fields["Fields.TPO.X90"]);

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={row?.id}
			onClick={() =>
				loanIncompleteStatusBoolean
					? navigate(`/edit-loan/${row?.loanGuid || row?.loanId}`)
					: navigate(`/loan-summary/${row?.loanGuid || row?.loanId}`)
			}
		>
			{/* loan number */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1
					text={
						loanIncompleteStatusBoolean
							? "Not Assigned"
							: row?.fields["Loan.LoanNumber"]
					}
					error={loanIncompleteStatusBoolean}
					isLink={row?.fields["Loan.LoanFolder"] !== "Portal - Not Submitted"}
					extraClass={styles.pipelineNumber}
				/>
			</TableCell>

			{/* borrower name */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1 text={row?.fields["Loan.BorrowerName"]} />
			</TableCell>

			{/* loan status */}
			<TableCell key={row?.id} align={row?.align}>
				{loanIncompleteStatusBoolean ? (
					<Stack direction="row" className={styles.incompleteStatusContainer}>
						<WarningIcon />
						<Body1
							text="Incomplete Application"
							error={loanIncompleteStatusBoolean}
						/>
					</Stack>
				) : (
					<Body1 text={loanStatus} />
				)}
			</TableCell>

			{/* start date */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1
					text={
						row?.fields["Fields.2025"] !== ""
							? row?.fields["Fields.2025"]?.split(" ")[0]
							: ""
					}
				/>
			</TableCell>

			{/* property address */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1
					text={`${row?.fields["Fields.URLA.X73"]}, ${row?.fields["Fields.URLA.X75"]}, ${row?.fields["Fields.12"]}, ${row?.fields["Fields.14"]} `}
				/>
			</TableCell>

			{/* loan program */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1 text={row?.fields["Fields.1401"]} />
			</TableCell>

			{/* expiration date */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1
					text={
						row?.fields["Fields.762"] !== ""
							? row?.fields["Fields.762"]?.split(" ")[0]
							: ""
					}
				/>
			</TableCell>

			{/* loan folder */}
			<TableCell key={row?.id} align={row?.align}>
				<Body1 text={row?.fields["Loan.LoanFolder"]} />
			</TableCell>
		</TableRow>
	);
};

export default PipelineRow;
